import { MEASUREMENT_UNIT_MAX_PRECISION } from '@square/dashboard-data/models/catalog/catalog-service-constants';
const SCALE_FACTOR = Math.pow(10, MEASUREMENT_UNIT_MAX_PRECISION);

/**
 * Converts a value to the Catalog API's decimal format by multiplying by 10^MEASUREMENT_UNIT_MAX_PRECISION.
 * @param {number} value - The value to convert.
 * @returns {number} - The converted value.
 */
export function convertToCatalogDecimal(value) {
  return Math.round(value * SCALE_FACTOR);
}

/**
 * Converts a value from the Catalog API's decimal format by dividing by 10^MEASUREMENT_UNIT_MAX_PRECISION.
 * @param {number} value - The value to convert.
 * @returns {number} - The converted value.
 */
export function convertFromCatalogDecimal(value) {
  return value / SCALE_FACTOR;
}